import GreetingText from 'components/GreetingText/GreetingText';
import { withGreetingTextProps } from 'viewModel/greetingText/withGreetingTextProps';

export default withGreetingTextProps(GreetingText);
